"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var abstract_measure_filter_dto_1 = require("./abstract-measure-filter-dto");
var filter_dto_builder_1 = require("../builder/filter-dto-builder");
var IsSpecificDayFilterDto = /** @class */ (function (_super) {
    __extends(IsSpecificDayFilterDto, _super);
    function IsSpecificDayFilterDto(onMeasurePathHolderId, value) {
        var _this = _super.call(this, filter_dto_builder_1.FilterDtoBuilder.FILTER, IsSpecificDayFilterDto.IS_SPECIFIC_DAY, onMeasurePathHolderId, null, null) || this;
        _this.value = value;
        return _this;
    }
    IsSpecificDayFilterDto.IS_SPECIFIC_DAY = 'isSpecificDay';
    return IsSpecificDayFilterDto;
}(abstract_measure_filter_dto_1.AbstractMeasureFilterDto));
exports.IsSpecificDayFilterDto = IsSpecificDayFilterDto;
//# sourceMappingURL=is-specific-day-filter-dto.js.map